import _ from "lodash";
import update from "immutability-helper";
import {
  createAIModalityAttachmentMutation,
  updateAiMessageMutation,
  deleteJobMutation,
  updateAITutorModalityMutation,
  deleteAIMessageMutation,
  updateAttachmentMutation,
  createAITutorModalityMutation,
} from "./AIChatMutations";
import { setToastMsg } from "Login/modules/LoginModule";
import client from "lib/apolloClient/client";
import {
  getAIConversationsFromCache,
  writeAIConversationsInCache,
} from "modules/CommonGraphqlHelpers";
import { getAIConversationsQuery } from "modules/CommonQuery";

export const createAIModalityAttachment = (input, refetchQueries) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: createAIModalityAttachmentMutation,
        variables: { input },
        refetchQueries,
        awaitRefetchQueries: !_.isEmpty(refetchQueries),
      });
      return _.get(response, "data.platform.createAttachment", []);
    } catch {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const createAITutorModality = (input, refetchQueries) => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: createAITutorModalityMutation,
        variables: { input },
        refetchQueries,
        awaitRefetchQueries: !_.isEmpty(refetchQueries),
      });
      return _.get(response, "data.platform.createAiTutorModality", []);
    } catch {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const updateAiMessage = input => {
  return async dispatch => {
    try {
      return await client.mutate({
        mutation: updateAiMessageMutation,
        variables: { input },
      });
    } catch {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const deleteIntegrationJob = ({ jobId }) => {
  return async () => {
    try {
      const { data } = await client.mutate({
        mutation: deleteJobMutation,
        variables: { input: { jobId } },
      });

      return data;
    } catch {
      return {};
    }
  };
};

export const updateAITutorModality = input => {
  return async dispatch => {
    try {
      const response = await client.mutate({
        mutation: updateAITutorModalityMutation,
        variables: { input },
      });
      return _.get(response, "data.platform.updateAiTutorModality.attachment");
    } catch {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};

export const deleteAiMessages = params => async dispatch => {
  const { messageId, messageIds, conversationId, shouldRefetch = true } =
    params || {};

  try {
    let idsToDelete = messageIds;

    if (messageId) {
      const conversation = getAIConversationsFromCache({ id: conversationId });

      const messages = _.get(conversation, "messages.edges", [])
        .map(edge => edge.node)
        .reverse();

      const currentMessage = _.find(messages, { id: messageId }) || {};
      const parentId = _.get(currentMessage, "parentMessage.id");

      idsToDelete = _.compact([messageId]);

      if (currentMessage?.authorType !== "user") {
        idsToDelete = _.filter(
          messages,
          m =>
            m.id === messageId || (parentId && m.parentMessage?.id === parentId)
        ).map(m => m.id);
      }
    }

    if (_.isEmpty(idsToDelete)) return;

    // Optimistically update cache if shouldRefetch is false
    if (!shouldRefetch && conversationId) {
      const conversation = getAIConversationsFromCache({ id: conversationId });

      const updatedConversation = update(conversation, {
        messages: {
          edges: {
            $set: _.filter(
              _.get(conversation, "messages.edges", []),
              edge => !_.includes(idsToDelete, _.get(edge, "node.id"))
            ),
          },
          totalCount: {
            $set:
              _.get(conversation, "messages.totalCount", 0) -
              _.size(idsToDelete),
          },
        },
      });

      writeAIConversationsInCache({
        variables: { id: conversationId },
        data: { node: updatedConversation },
      });
    }

    return client.mutate({
      mutation: deleteAIMessageMutation,
      variables: { input: { ids: idsToDelete } },
      ...(conversationId &&
        shouldRefetch && {
          refetchQueries: [
            {
              query: getAIConversationsQuery,
              variables: { id: conversationId },
            },
          ],
          awaitRefetchQueries: true,
        }),
    });
  } catch {
    dispatch(setToastMsg("toastMsgs:something_went_wrong"));
  }
};

export const updateAttachment = params => {
  return async dispatch => {
    const { portalType = "PLANNER", ...inputParams } = params;
    try {
      const response = await client.mutate({
        mutation: updateAttachmentMutation,
        variables: {
          input: inputParams,
          skipModalityAttachment:
            _.get(inputParams, "metadata.updatePresetAttachment", false) &&
            !_.get(inputParams, "modalityFile.metadata"),
          portalType,
        },
      });

      return _.get(response, "data.platform.updateAttachment.attachment");
    } catch {
      dispatch(setToastMsg("toastMsgs:something_went_wrong"));
    }
  };
};
